<one-card class="no-padding">
  <one-dynamic-table #table [tableData]="TABLE_DATA"></one-dynamic-table>
</one-card>
